import React from 'react';
import './ReservationPage.css';

import Navigation from '../../Shared/Navigation/Navigation';
import ReservationBanner from '../../PageCompos/Reservations/ReservationBanner/ReservationBanner';
import ReservationForm from '../../PageCompos/Reservations/ReservationForm/ReservationForm';
import Footer from '../../Shared/Footer/Footer';
import Gallery from '../../PageCompos/Home/Gallery/Gallery';

const ReservationPage = () => {
    return (
        <>
            <Navigation />
            <ReservationBanner />
            <div style={{ backgroundColor: "#021d2a", color: "#fff" }}>
                <ReservationForm />
            </div>
            <Gallery />
            <Footer />
        </>
    );
};

export default ReservationPage;